import { render, staticRenderFns } from "./recommendPostList.vue?vue&type=template&id=7f4fc910&scoped=true&"
import script from "./recommendPostList.vue?vue&type=script&lang=js&"
export * from "./recommendPostList.vue?vue&type=script&lang=js&"
import style0 from "./recommendPostList.vue?vue&type=style&index=0&id=7f4fc910&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f4fc910",
  null
  
)

export default component.exports